import { render, staticRenderFns } from "./UserInstance.vue?vue&type=template&id=a08d04b6&scoped=true"
import script from "./UserInstance.vue?vue&type=script&lang=js"
export * from "./UserInstance.vue?vue&type=script&lang=js"
import style0 from "./UserInstance.vue?vue&type=style&index=0&id=a08d04b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08d04b6",
  null
  
)

export default component.exports